
import { Oauth2Flow, oaut2PropDisplayName, oaut2Properties, services } from "./trigger.enum";


export class PropertyMeta implements IPropertyMeta {
    name: string;
    displayName: string;
    passwordmode: boolean;
    propertyValues: string[];
    required: boolean;
    canEdit: boolean;
    canDelete: boolean;
    value: any;
    selected: boolean;
    copy: boolean;
    hidden: boolean;
    restart: boolean;
    pattern: string;
    title: string;
    disabled: boolean;
    constructor(name: string, displayName: string, passwordmode: boolean, propertyValues: string[], required: boolean, canEdit: boolean, canDelete: boolean, value: any, hidden?: boolean, copy?: boolean, restart?: boolean,
        pattern?: string, title?: string) {
        this.name = name;
        this.displayName = displayName;
        this.passwordmode = passwordmode;
        this.propertyValues = propertyValues;
        this.required = required;
        this.canEdit = canEdit;
        this.canDelete = canDelete;
        this.value = value;
        this.selected = false;
        this.copy = copy || false;
        this.hidden = hidden || false;
        this.restart = restart || false;
        this.pattern = pattern || "";
        this.title = title || "";
        this.disabled = false;
    }

    restartValue(value: any) {
        this.value = value;
    }

    getKeyValue(): Data {
        let data = null;
        if (this.name && this.name.length > 0) {
            data = new Data(this.name, this.value);
        }
        return data;
    }
    validateMissing(): string {
        if (!this.disabled && this.required && !(this.value.toString().length > 0)) {
            return this.displayName;
        } else {
            return null;
        }
    }
    missingValue(): any {
        if (!(this.value && this.value.toString().length > 0)) {
            return this.name;
        } else {
            return false;
        }
    }

    hasDefaultValue(): boolean {
        let hasValue = false;
        if (this.propertyValues && this.propertyValues.length > 0) {
            hasValue = true;
        }
        return hasValue;
    }
    
    /**
     * Creates a shallow copy of the Trigger object.
     * 
     * @returns A new instance of the Trigger object with the same property values.
     */
    clone(): IPropertyMeta {
        return new PropertyMeta(
            this.name,
            this.displayName,
            this.passwordmode,
            this.propertyValues,
            this.required,
            this.canEdit,
            this.canDelete,
            this.value,
            this.hidden,
            this.copy,
            this.restart,
            this.pattern,
            this.title
        );
    }
}
export class Data implements IData {
    key: string;
    value: string;
    constructor(key: string, value: string) {
        this.key = key;
        this.value = value;
    }
}

export class DefatultMetaParam {
    equivalences = new Map([
        [oaut2Properties.response_type.toString(), "responseType"],
        [oaut2Properties.redirect_uri.toString(), "redirectUri"],
        [oaut2Properties.client_id.toString(), "clientId"],
        [oaut2Properties.client_secret.toString(), "clientSecret"],
        [oaut2Properties.auth_url.toString(), "authUrl"],
        [oaut2Properties.token_url.toString(), "tokenUrl"],
        [oaut2Properties.scope.toString(), "scope"],
        [oaut2Properties.token_access_type.toString(), "tokenAccessType"],
        [oaut2Properties.grant_type.toString(), "grantType"],
        [oaut2Properties.tenant_id.toString(), "tenantId"],
        [oaut2Properties.resource_id.toString(), "resourceId"],
        [oaut2Properties.tenant_name.toString(), "tenantName"],
        [oaut2Properties.url.toString(), "url"],
        [oaut2Properties.itemNameOrPath.toString(), "itemNameOrPath"],
    ]);

    copyDataToMetaParameters(metaPropertiesList: IPropertyMeta[], authParam: IPropertyKeyValue[]) {
        metaPropertiesList.forEach(prop => prop.value = authParam.find(param => param.key == this.equivalences.get(prop.name))?.value || "");
    }

    copyMetaParametersToData(metaPropertiesList: IPropertyMeta[]) {
        return metaPropertiesList.map(prop => ({
            key: this.equivalences.get(prop.name),
            value: prop.value
        }));
    }

    updateRedirecUri(metaPropertiesList: IPropertyMeta[], redirectUri:string) {        
        var propRedirect = metaPropertiesList.find(prop => prop.name == oaut2Properties.redirect_uri);
        if(propRedirect){
            propRedirect.value = redirectUri;
        }        
    }

    copyMetaParamToMetaParm(propListOrgin: IPropertyMeta[], propListDes: IPropertyMeta[]) {
        propListOrgin.forEach(propOrig => {
            var prop = propListDes.find((val) => val.name == propOrig.name);
            if (prop && !prop.value) {
                prop.value = propOrig.value;
            }
        });
    }
    copyOauthToken(authTokenOrig: IConnectionDetails, authTokenDes: IConnectionDetails) {
        if (authTokenOrig?.tokenCredentials?.accessToken) {
            authTokenDes["tokenCredentials"] = authTokenOrig?.tokenCredentials;
        }
    }

    copyConfigEnvFromDevToOthers() {
    }

    loadMetaParamListByOauthType(service, redirectUri: string) {
        let redirectURI = redirectUri || "https://build.bizagi.com/redirectOauth2.html";
        let metaProperties: IPropertyMeta[] = [];
        let patterUrlOnlySecure = "^(https)\://([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&amp;%\$\-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(\:[0-9]+)*(/($|[a-zA-Z0-9\.\,\?\'\\\+&amp;%\$#\=~_\-]+))*$";
        let patterUrl = "^(http|https)\://([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&amp;%\$\-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(\:[0-9]+)*(/($|[a-zA-Z0-9\.\,\?\'\\\+&amp;%\$#\=~_\-]+))*$";
        if (service == services.sharepoint) {
            metaProperties.push(
                new PropertyMeta(oaut2Properties.client_id, oaut2PropDisplayName.client_id, true, [], true, true, false, ""),
                new PropertyMeta(oaut2Properties.client_secret, oaut2PropDisplayName.client_secret, true, [], true, true, false, ""),
                new PropertyMeta(oaut2Properties.itemNameOrPath, oaut2PropDisplayName.listName, false, [], true, true, false, ""),
                new PropertyMeta(oaut2Properties.tenant_name, oaut2PropDisplayName.tenant_name, false, [], true, true, false, ""),
                new PropertyMeta(oaut2Properties.tenant_id, oaut2PropDisplayName.tenant_id, false, [], true, true, false, ""),
                new PropertyMeta(oaut2Properties.resource_id, oaut2PropDisplayName.resource_id, false, [], true, true, false, ""),
                new PropertyMeta(oaut2Properties.url, oaut2PropDisplayName.url, false, [], true, true, false, "", false, false, false, patterUrl),
                new PropertyMeta(oaut2Properties.grant_type, oaut2PropDisplayName.grant_type, false, [], true, false, false, Oauth2Flow.clientCredencialGrants)
            )
        }
        if (service == services.dropbox) {
            metaProperties.push(
                new PropertyMeta(oaut2Properties.client_id, oaut2PropDisplayName.client_id, true, [], true, true, false, ""),
                new PropertyMeta(oaut2Properties.client_secret, oaut2PropDisplayName.client_secret, true, [], true, true, false, ""),
                new PropertyMeta(oaut2Properties.itemNameOrPath, oaut2PropDisplayName.folderPath, false, [], true, true, false, ""),
                new PropertyMeta(oaut2Properties.response_type, oaut2PropDisplayName.response_type, false, [], true, false, false, Oauth2Flow.AutorizationCodeGrant),
                new PropertyMeta(oaut2Properties.redirect_uri, oaut2PropDisplayName.redirect_uri, false, [], true, false, false, redirectURI, false, true),
                new PropertyMeta(oaut2Properties.auth_url, oaut2PropDisplayName.auth_url, false, [], true, false, false, 'https://www.dropbox.com/oauth2/authorize', true),
                new PropertyMeta(oaut2Properties.token_url, oaut2PropDisplayName.token_url, false, [], true, false, false, "https://api.dropbox.com/oauth2/token", true),
                new PropertyMeta(oaut2Properties.token_access_type, oaut2PropDisplayName.token_access_type, false, [], true, false, false, "offline", true)
            )
        }
        return metaProperties;
    }
}

export class AuthorizationCodeGrant implements IAuthorizationCodeGrant {
    expiresIn: number;
    accessToken: string;
    refreshToken: string;
    connectorSystemGuid: string;
    environmentType: number;
    accessTokenCreationDateUtc: Date;

    constructor(object: AuthorizationCodeGrant) {
        if (object) {
            this.expiresIn = object.expiresIn;
            this.accessToken = object.accessToken;
            this.refreshToken = object.refreshToken;
            this.connectorSystemGuid = object.connectorSystemGuid;
            this.environmentType = object.environmentType;
            this.accessTokenCreationDateUtc = object.accessTokenCreationDateUtc;
        }
    }
    isValidToken(): boolean {
        let ok = false;
        if (this.accessToken && this.refreshToken) {
            ok = true;
        } else if (this.accessTokenCreationDateUtc) {
            let dateCreation = Date.parse(this.accessTokenCreationDateUtc.toString())
            let dateExpires = dateCreation + (this.expiresIn * 1000);
            let dateActually = Date.parse(new Date().toUTCString());
            ok = dateActually <= dateExpires
        }
        return ok;
    }
}